import { Component, OnInit } from '@angular/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SelectItem, MessageService } from 'primeng/api';
import * as fromStore from '../store';
import { Store } from '@ngrx/store';
import * as fromFeature from '../my-features';
import { RegionService } from 'src/app/services/region.service';
import { ActivatedRoute } from '@angular/router';
import { CryptoService} from '../services/crypto.service';
import { UpdateInfoModel } from '../my-features/updateInfo/update-info.model';
import { updateInfoType, GateWayStatus, CheckDiscoveryJobBySec } from '../shareModel';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-gateway',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.css']
})
export class GatewayComponent implements OnInit {
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  gatewayType: string = "0";
  gatewayList = [];
  gatewayDic = [];
  gatewayData = [];
  containDeviceGateway = [];
  displayConfirmDialog: boolean = false;
  displayWarningDialog: boolean = false;
  deleteGatewayItem: any = null;
  isMsp:boolean = false;	
  displayDeleteBtn:boolean = false;	
  intervalId: any = null;
  reloadgateway = false;
  gatewayloaded = false;
  params: {
    otp: string;
    RegionIds?: [];
  };
  rgionDic = [];
  editProAuth = false;
  editRgionProAuthDic = [];
  IsSuperAdmin = false;
  constructor(
    private translateService: TranslateService,
    private store: Store<fromStore.State>,
    private regionService: RegionService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private cryptoService: CryptoService, 
    private router: Router) {
    const tab = this.cryptoService.aesDecrypt(this.route.snapshot.queryParamMap.get('tab'));
    if (tab !== undefined && tab !== null) {
      this.gatewayType = tab;
    }
    this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe(user => {
      if (!this.reloadgateway && user != undefined && !user.isLoading && user.isLoaded && user.isLogin) {
        this.IsSuperAdmin = user.authority === 2;
        this.isMsp = user.isMsp;
        if (!user.isMsp) {
          this.store.dispatch(new fromFeature.ReadMibTrapList());
          this.store.dispatch(new fromFeature.ReadGatewayList({ ...this.params }));
          this.store.dispatch(new fromFeature.ReadProfileList({ ...this.params }));
          this.store.dispatch(new fromFeature.ReadCategoryListByUser());
          this.store.dispatch(new fromFeature.ReadDiscoveryInfoList({ ...this.params }));
          this.store.dispatch(new fromFeature.ExecuteDiscoveryList({ ...this.params }));
          this.store.dispatch(new fromFeature.ReadDiscoveryResultList({ ...this.params }));
          this.store.dispatch(new fromFeature.GetNotifications());
          this.reloadgateway = true;
          this.editProAuth = true;
        }
      }
    })

    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(mspFilter => {
      if (mspFilter !== null && mspFilter.filterLoaded && mspFilter.isMsp) {
        this.params = {
          otp: '',
          RegionIds: mspFilter.selectedId,
        };
          this.store.dispatch(new fromFeature.ReadMibTrapList());
        this.store.dispatch(new fromFeature.ReadGatewayList({ ...this.params }));
        this.store.dispatch(new fromFeature.ReadProfileList({ ...this.params }));
        this.store.dispatch(new fromFeature.ReadCategoryListByUser());
        this.store.dispatch(new fromFeature.ReadDiscoveryInfoList({ ...this.params }));
        this.store.dispatch(new fromFeature.ExecuteDiscoveryList({ ...this.params }));
        this.store.dispatch(new fromFeature.ReadDiscoveryResultList({ ...this.params }));
        this.store.dispatch(new fromFeature.GetNotifications());
      }
    })

    // Get Msp
    this.store
      combineLatest(this.store.select(fromStore.getRegions), this.store.select(fromStore.getMspMemberAuthority), this.store.select(fromStore.getMspRegionFilter))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([region, mspAuth, mspFilter]) => {
        if (region !== undefined && region.length > 0 && this.isMsp) {
          this.editProAuth = true;
          if (mspAuth !== undefined && mspAuth.length > 0) {
            this.rgionDic = [];
            this.editRgionProAuthDic = [];
            region.map(r => {
              this.rgionDic[r.Id] = r;
            })
            if (this.rgionDic.length > 0) {
              mspAuth.map((m) => {
                if (this.editRgionProAuthDic[m.RegionId] == undefined) {
                  this.editRgionProAuthDic[m.RegionId] = {};
                  this.editRgionProAuthDic[m.RegionId] = m;
                }
                if (this.rgionDic[m.RegionId] !== undefined 
                  && mspFilter !== null && mspFilter.selectedId !== null && mspFilter.selectedId.length > 0) {
                    if (m.EditDevice == 1) {
                      this.editProAuth = true;
                    }
                }
              })

              if (mspFilter !== null && mspFilter.selectedId !== null && mspFilter.selectedId.length == 1) {
                // 防止選擇單一Region且只有View權限的還能看到Auto-Discovery、SnmpProfile的Tag
                if (this.editRgionProAuthDic && this.editRgionProAuthDic[mspFilter.selectedId[0]].EditDevice !== 1) {
                  this.editProAuth = false
                }
              }
            }
      
            if (!this.editProAuth) {
              if (this.gatewayType !== '0') { // connect-device
                this.router.navigate(['/index']);
              }
            }
          }
        }
      });

    // Get GateWay List Dic
    this.store.select(fromStore.ReadGateWayList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        this.gatewayloaded = true;
        if (res.entities !== undefined && res.entities !== null && Array.isArray(res.entities)) {
          // gateway全部刪除
          this.gatewayDic = [];
          this.gatewayData = [];
          if ( res.entities.length > 0) {
            this.gatewayData = res.entities.map((g) => ({ ...g }));
            this.gatewayData.forEach((g) => {
              this.gatewayDic[g.Id] = g;
            })
            this.getGateway();
          }
        } else {
          this.gatewayList = [];
        }
      }
    })

    // Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.DeleteGateway) {
          this.messageService.clear();
          if (res.isSaved) {
            this.messageService.add({ severity: 'success', summary: this.translateService.instant(TRANSLATE('success')) });
            this.store.dispatch(new fromFeature.ReadGatewayList({ ...this.params }));
          } else {
            this.displayWarningDialog = true;
            this.displayConfirmDialog = false;
          }
          this.resetUpdateInfoState();
        }
      }
    })
  }

  ngOnInit() {
  }

  getGateway() {
    if (this.gatewayData !== undefined && this.gatewayData.length > 0) {
      this.gatewayList = [];
      this.gatewayData.map((g) =>{
        let disable = false;
        let hideDeleteBtn = false;
        if (this.containDeviceGateway !== undefined && this.containDeviceGateway.length > 0 && this.containDeviceGateway.find(s => s == g.Id) !== undefined) {
          disable = true;
        }
        // 沒有編輯權限的gateway只能看不能刪
        if (this.editRgionProAuthDic[g.RegionId] !== undefined) {
          if (this.editRgionProAuthDic[g.RegionId].ViewDevice === 1 && this.editRgionProAuthDic[g.RegionId].EditDevice === 0) {
              hideDeleteBtn = true;
          }
        }
        this.gatewayList.push({
          id: g.Id,
          name: g.Name,
          status: GateWayStatus[g.Status],
          disable: disable,
          hideDeleteBtn: hideDeleteBtn,
          versionStatus: g.VersionStatus !== undefined ? parseInt(g.VersionStatus) : 0
        });
      })
      this.gatewayList = [...this.gatewayList];
    }
  }

  onTabChange(event) {
    this.gatewayType = event;
  }

  // showConfirmDialog(item) {
  //   if (item.disable) {
  //     this.displayWarningDialog = true;
  //     this.displayConfirmDialog = false;
  //   } else {
  //     this.displayConfirmDialog = true;
  //     this.displayWarningDialog = false;
  //     this.deleteGatewayItem = item;
  //   }
  // }
  
  advancedSetting() {
    this.router.navigate(['/gateway-setting/advanced']);
  }

  // deleteGateway() {
  //   this.displayConfirmDialog = false;
  //   if (this.deleteGatewayItem !== undefined && this.deleteGatewayItem !== null) {
  //     const param = {
  //       otp: '',
  //       Id: this.deleteGatewayItem.id
  //     }
  //     this.store.dispatch(new fromFeature.DeleteGateway(param));
  //   }
  // }

  ngOnDestroy(): void {
    // this.stopInterval();
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

}
